import { queryExtendedBookings } from '@wix/ambassador-bookings-reader-v2-extended-booking/http';
export const getBooking = async ({ bookingId }, { httpClient }) => {
    const { data: response } = await httpClient.request(queryExtendedBookings({
        query: {
            filter: {
                id: bookingId,
            },
        },
    }));
    return response?.extendedBookings?.[0]?.booking;
};
//# sourceMappingURL=getBooking.js.map